import styled from "styled-components";

/**
 * Divisão entre paradas nos voos.
 */
export const StopContainer = styled.div`
  margin: ${({ theme }) => theme.spacing(2)}
    ${({ theme }) => theme.spacing(5.5)} 0;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  display: flex;
`;
